import PermissionsRequired from './PermissionsRequired'

export default PermissionsRequired
